<template>
  <div class="relative">
    <div
      class="absolute -top-4 right-4 flex -translate-y-full animate-pulse items-center gap-2"
    >
      <svg
        class="fill-gray-600 mt-2 w-8 -rotate-[24deg] opacity-60"
        viewBox="0 0 219 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3_248)">
          <path
            d="M21.489 29.4305C36.9333 31.3498 51.3198 33.0559 65.7063 34.9753C66.7641 35.1885 67.6104 36.4681 69.9376 38.3875C63.1675 39.2406 57.8783 40.3069 52.5892 40.5201C38.6259 40.9467 24.8741 40.9467 10.9107 40.9467C9.21821 40.9467 7.5257 41.1599 5.83317 40.7334C0.332466 39.6671 -1.57164 36.0416 1.39028 31.1365C2.87124 28.7906 4.56377 26.658 6.46786 24.7386C13.6611 17.4876 21.0659 10.4499 28.4707 3.41224C29.7401 2.13265 31.6442 1.49285 34.183 0C34.6061 10.8765 23.8162 13.8622 21.489 22.3927C23.3931 21.9662 25.0856 21.7529 26.5666 21.3264C83.6894 5.54486 140.601 7.25099 197.3 22.606C203.224 24.0988 208.936 26.4447 214.649 28.5773C217.61 29.6437 220.149 31.9896 218.457 35.6151C216.976 39.2406 214.014 39.2406 210.629 37.7477C172.759 20.6866 132.561 18.7672 91.9404 19.407C70.7838 19.6203 50.0504 21.9662 29.5285 26.8713C26.9897 27.5111 24.4509 28.3641 21.489 29.4305Z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_3_248">
            <rect width="219" height="41"></rect>
          </clipPath>
        </defs>
      </svg>
      <span class="text-gray-600 text-sm">{{ $t('landing.demo.interactiveDemo') }}</span>
    </div>

    <BaseOutline>
      <div class="relative">
        <div
          id="demo-container"
          class="group relative mx-auto flex flex-col rounded-2xl border border-gray-900/5 shadow-[0_1px_1px_rgba(0,0,0,0.08)] overflow-hidden"
        >
          <div
            class="relative z-10 flex w-full items-center border-b-[0.5px] border-gray-900/5 bg-white px-4 py-2 shadow-[0_1px_1px_rgba(0,0,0,0.08)]"
          >
            <div
              class="absolute left-4 top-1/2 flex -translate-y-1/2 items-center justify-start space-x-1.5"
            >
              <span class="size-2.5 rounded-full bg-red-400"></span
              ><span class="size-2.5 rounded-full bg-yellow-400"></span
              ><span class="size-2.5 rounded-full bg-green-400"></span>
            </div>

            <div class="w-full text-center text-sm">
              <span class="text-gray-600 opacity-50">https://capino.app</span>
            </div>
          </div>

          <TheDemo class="w-full bg-capino-light" />

          <!-- <iframe
            src="/demo"
            class="w-full bg-capino-light"
            width="1000"
            height="1000"
            :style="
              demoSectionsHeight > 0
                ? { height: demoSectionsHeight + 'px' }
                : {}
            "
            title="Capino App Demo - Grammar Learning Tool"
            aria-label="Interactive demo showing Capino with grammar learning tool"
            ><p>
              View our
              <a class="link link-primary" href="/hub/sections"
                >interactive demo</a
              >to see how Capino helps you master grammar.
            </p></iframe
          > -->
        </div>
      </div>
    </BaseOutline>
  </div>
</template>

<script>
import BaseOutline from '@/components/Base/BaseOutline.vue'
import TheDemo from '@/components/Demo/TheDemo.vue'

export default {
  name: 'LandingDemo',

  components: { BaseOutline, TheDemo }

  // data: () => ({
  //   mutationObserver: null,
  //   resizeObserver: null,
  //   demoSectionsHeight: 0
  // })

  // mounted() {
  //   this.setupDemoSectionsObserver()
  // },

  // beforeDestroy() {
  //   this.mutationObserver?.disconnect()
  //   this.resizeObserver?.disconnect()
  // },

  // methods: {
  //   setupDemoSectionsObserver() {
  //     const iframe = document.querySelector('iframe[src="/demo"]')

  //     // Wait for iframe to load
  //     iframe.addEventListener('load', () => {
  //       try {
  //         const iframeDoc =
  //           iframe.contentDocument || iframe.contentWindow.document

  //         // Create MutationObserver to watch for demo-sections element
  //         this.mutationObserver = new MutationObserver(mutations => {
  //           mutations.forEach(mutation => {
  //             if (mutation.type === 'childList') {
  //               const demoSections = iframeDoc.getElementById('demo-sections')
  //               if (demoSections) {
  //                 this.setDemoSectionsHeight(demoSections)

  //                 // Set up ResizeObserver for the demo-sections element
  //                 this.setupResizeObserver(demoSections)

  //                 // Disconnect mutation observer since we found the element
  //                 this.mutationObserver.disconnect()
  //               }
  //             }
  //           })
  //         })

  //         // Start observing the iframe document for changes
  //         this.mutationObserver.observe(iframeDoc.body, {
  //           childList: true,
  //           subtree: true
  //         })

  //         // Check if demo-sections already exists
  //         const existingDemoSections = iframeDoc.getElementById('demo-sections')
  //         if (existingDemoSections) {
  //           this.setDemoSectionsHeight(existingDemoSections)
  //           this.setupResizeObserver(existingDemoSections)
  //           this.mutationObserver.disconnect()
  //         }
  //       } catch (error) {
  //         console.warn(
  //           'Cannot access iframe content due to cross-origin restrictions:',
  //           error
  //         )
  //       }
  //     })
  //   },

  //   setupResizeObserver(demoSections) {
  //     this.resizeObserver = new ResizeObserver(() => {
  //       this.setDemoSectionsHeight(demoSections)
  //     })

  //     this.resizeObserver.observe(demoSections)
  //   },

  //   setDemoSectionsHeight(demoSections) {
  //     if (demoSections) {
  //       this.demoSectionsHeight = demoSections.clientHeight
  //     }
  //   }
  // }
}
</script>
